import { debounce } from 'lodash'
import { onBeforeUnmount } from 'vue'

import { scrollToComments, shouldScrollToComments } from '@/utils/scrollTo-utils'

const SCROLL_DELAY_MS = 100
const OBSERVER_DELAY_MS = 500
const OBSERVER_LIFETIME_MS = 3000

export const useScrollToComments = () => {
  let mutationObserver = null
  let debouncedScrollToCommentsForMutationObserver = null
  let observerLifetimeTimeout = null

  const setup = payload => {
    if (!shouldScrollToComments(payload)) return

    // Default behavior

    // NOTE: added debounce wrapper to account for render and modal
    // transition duration, otherwise there would be sharp jump of modal container. See task OK-2749.
    const debouncedScrollToComments = debounce(payload => {
      scrollToComments(payload)
    }, SCROLL_DELAY_MS)

    debouncedScrollToComments()

    if (!payload?.target) return

    observerLifetimeTimeout = setTimeout(() => {
      disconnect()
    }, OBSERVER_LIFETIME_MS)

    debouncedScrollToCommentsForMutationObserver = debounce(payload => {
      scrollToComments(payload)
      disconnect()
      clearObserverLifetimeTimeout()
    }, OBSERVER_DELAY_MS)

    mutationObserver = new MutationObserver(() => {
      debouncedScrollToCommentsForMutationObserver(payload)
    })

    mutationObserver.observe(payload.target, {
      childList: true,
      subtree: true
    })
  }

  const disconnect = () => {
    if (!mutationObserver) return

    mutationObserver.disconnect()
    mutationObserver = null
  }

  const clearObserverLifetimeTimeout = () => {
    if (observerLifetimeTimeout === null) return

    clearTimeout(observerLifetimeTimeout)
    observerLifetimeTimeout = null
  }

  onBeforeUnmount(() => {
    disconnect()
    clearObserverLifetimeTimeout()
  })

  return {
    setup,
    disconnect
  }
}
